<lib-pegase-menu>
    <div id="nav-content">
        <mat-nav-list>
            @if (structure$ | async; as structure) {
            <lib-pegase-menu-entry-with-children
                [navTitle]="'Espaces de travail'"
                [matIcon]="'event_available'"
                *appShowIfAutorise="ODF_RECHERCHER_ESPACES"
            >
                <lib-pegase-menu-entry
                    [path]="structure + '/espaces/recherche'"
                    [navTitle]="'Recherche'"
                    [matIcon]="'search'"
                    *appShowIfAutorise="ODF_RECHERCHER_ESPACES"
                ></lib-pegase-menu-entry>
                <lib-pegase-menu-entry
                    [path]="structure + '/annee/recherche'"
                    [navTitle]="'Année universitaire'"
                    [matIcon]="'calendar_month'"
                    *appShowIfAutorise="ODF_RECHERCHER_ESPACES"
                ></lib-pegase-menu-entry>
            </lib-pegase-menu-entry-with-children>
            <lib-pegase-menu-entry-with-children [navTitle]="'Maquettes'" [matIcon]="'lan'" *appShowIfAutorise="ODF_LIRE_OBJET_MAQUETTE">
                <lib-pegase-menu-entry
                    [path]="structure + '/objets-maquette/recherche'"
                    [navTitle]="'Rechercher'"
                    [matIcon]="'search'"
                    *appShowIfAutorise="ODF_RECHERCHER_OBJET_MAQUETTE"
                ></lib-pegase-menu-entry>
                <lib-pegase-menu-entry
                    [path]="structure + '/objets-maquette/editeur'"
                    [navTitle]="'Editeur'"
                    [matIcon]="'edit_square'"
                    *appShowIfAutorise="ODF_LIRE_STRUCTURE_MAQUETTE"
                ></lib-pegase-menu-entry>
                <lib-pegase-menu-entry
                    [path]="structure + '/objets-maquette/importer'"
                    [navTitle]="'Importer'"
                    [matIcon]="'upload'"
                    *appShowIfAutorise="ODF_IMPORTER_MAQUETTE_BASE64_VERS_ESPACE"
                ></lib-pegase-menu-entry>
                <lib-pegase-menu-entry
                    [path]="structure + '/objets-maquette/copie-en-masse'"
                    [navTitle]="'Copier en masse'"
                    [matIcon]="'send'"
                    *appShowIfAutorise="ODF_COPIER_MAQUETTE_EXISTANT_VERS_ESPACE"
                ></lib-pegase-menu-entry>
            </lib-pegase-menu-entry-with-children>
            <lib-pegase-menu-entry
                [path]="structure + '/diplomes/recherche'"
                [navTitle]="'Diplômes / certificats / autres'"
                [matIcon]="'description'"
                *appShowIfAutorise="ODF_RECHERCHER_DIPLOMES"
            ></lib-pegase-menu-entry>
            }
        </mat-nav-list>
    </div>
    <div id="main-content">
        <lib-pegase-header [title]="'Offre de formation'" icon="construction">
            <div id="header-extra-element">
                @if (showEspaceSelected) {
                <app-espace-indicator></app-espace-indicator>
                } @if (documentationUrl$ | async; as documentationUrl) { @if (false) {
                <a [href]="documentationUrl" data-tfa="documentation_url" class="help" matTooltip="Guide utilisateur">
                    <mat-icon fontIcon="help" data-tfa="documentation_icon"></mat-icon>
                </a>
                } }
            </div>
            <lib-authentication-form></lib-authentication-form>
            <lib-auth-silent></lib-auth-silent>
        </lib-pegase-header>

        <main id="top" role="main">
            <div id="content">
                @if (loading$ | async; as loading) { @if (loading) {
                <div class="centralLoader">
                    <mat-spinner color="accent" diameter="50" mode="indeterminate"></mat-spinner>
                </div>
                } }
                <router-outlet></router-outlet>
            </div>
        </main>
        <lib-pegase-footer version="ODF - {{ version }}"></lib-pegase-footer>
    </div>
</lib-pegase-menu>
